module.exports = __webpack_public_path__ + "static/media/osdev.2d2394a0.jpg";